<template>
    <div class="attachment-dialog">
        <div class="attachment-widget-wrapper">
          <input
            type="file"
            ref="fileInput"
            style="display: none"
            multiple
            @change="handleSelect"
          />
        <div v-if="show" class="attachment-widget">
            <header class="attachment-header">
                <h3 v-text="headerTitle"></h3>
                <button class="close-button" @click.prevent.stop="attachments = []; internalShow = false;">
                  <IconClose />
                </button>
            </header>
          <div class="attachments-container">
            <div
              class="attachment-tile"
              :class="[`attachment-tile--${attachment.type}`]"
              v-for="attachment in attachments"
              :key="attachment.id"
            >
              <a  v-if="attachment.type === 'pdf'" class="pdf-container" target="_blank" :href="attachment.preview">
                    <IconPDF class="pdf-icon" />
                    <div class="pdf-name">
                        <div class="pdf-filename">{{attachment.name}}</div>
                        <div class="pdf-size">{{ formatSize(attachment.size) }}</div>
                    </div>
                <button class="delete-button" @click.prevent.stop="onAttachmentRemoved(attachment)">
                  <Trash />
                </button>
            </a>
              <div v-else class="image-container">
                <a target="_blank" :href="attachment.preview">
                    <img
                      draggable="false"
                      :src="attachment.preview"
                      alt="preview"
                      @load="event => workaroundFirefoxBug(event)"
                      />
                </a>
                <button class="delete-button" @click="onAttachmentRemoved(attachment)">
                  <Trash />
                </button>
              </div>
            </div>
            <button ref="addButton" class="tile-add" @click="triggerFileInput" @drop.prevent.stop="handleDrop" @dragenter="$refs.addButton.classList.add('dragging')" @dragleave="$refs.addButton.classList.remove('dragging')">
                <IconPlus />
            </button>
          </div>
        </div>
      </div>
      </div>
</template>

<script>
import IconPlus from 'assets/icons/plus.svg'
import IconClose from 'assets/icons/close.svg'
import IconPDF from 'assets/icons/pdf_icon.svg'
import Trash from 'assets/icons/trash.svg'


export default {
  components: {
    IconClose,
    IconPlus,
    IconPDF,
    Trash
  },

  props: {
    show: {
        type: Boolean,
        default: false
    }
  },
  data: () => ({
    attachments: [],
    maxFiles: 5,
    maxFileSize: 10,
    acceptedFiles: [
      'application/pdf',
      'image/jpeg',
      'image/png'
    ],
    internalShow: false
  }),
  created() {
    this.internalShow = !!this.show
  },
  computed: {
    headerTitle() {
      if (this.attachments.length > 0 && this.attachments.filter(el => el.type === 'image').length === this.attachments.length) {
        return this.$t('chat.attachments.titleMultipleImages', {count: this.attachments.length}) 
      }
      return this.$t('chat.attachments.titleMixed', { count: this.attachments.length})

    }
  },

  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
      this.internalShow = true
    },

    handleSelect(event) {
      if(this.disabled) {
        return
      }
      this.internalShow = true
      this.processFiles(event.target.files);
    },

    handleDrop(event) {
        this.addFiles(event.dataTransfer.files)

    },
    addFiles(files) {
    this.internalShow = true
      this.processFiles(files);
    },

    reset() {
        this.internalShow = false
        this.attachments = []
    },
    
    async processFiles(fileList) {
      if(fileList.length + this.attachments.length > this.maxFiles) {
        this.$message({
          type: 'warning',
          message: this.$t('system.uploadBox.fileLimitExceeded')
        })
        return
      }

      for (const file of fileList) {
        if(this.validateFile(file)) {
          const type = file.type === 'application/pdf' ? 'pdf' : 'image'
          this.attachments.push({
            id: crypto.randomUUID(),
            preview: URL.createObjectURL(file),
            type: type,
            name: file.name,
            size: file.size,
            file
          })
        }
      }
    },

    formatSize(size) {
        if (size < 1e3) {
            return "0." + size + " kB"
        }
        if (size < 1e6) {
            const kb = size / 1e3
            return new Intl.NumberFormat("de-DE", { maximumFractionDigits: 1 }).format(kb) + " kB"
        }
        const mb = size / 1e6
        return new Intl.NumberFormat("de-DE", { maximumFractionDigits: 1 }).format(mb) + " MB"

    },

    async onAttachmentRemoved(file) {
      if(!file) {
        return
      }
      this.attachments = this.attachments.filter(item => item.id != file.id)
    //   if (this.attachments.length === 0) {
    //     this.internalShow = false
    //   }
    },

    validateFile(file) {
      let isAccepted = this.acceptedFiles.includes(file.type)
      if(!isAccepted) {
        this.$message({
          type: 'warning',
          message: this.$t('system.uploadBox.fileTypeNotSupported')
        })
        return isAccepted
      }
      isAccepted = file.size / (1024 * 1024) <= this.maxFileSize
      if(!isAccepted) {
        this.$message({
          type: 'warning',
          message: this.$t('system.uploadBox.fileSizeToLarge')
        })
      }
      return isAccepted
    },
    workaroundFirefoxBug(event) {
        if (event.target.closest('.image-container').offsetWidth !== event.target.closest('.attachment-tile').offsetWidth) {
            console.log('adjust image size', event.target)
            event.target.closest('.attachment-tile').style=`box-sizing: content-box;width:${event.target.closest('.image-container').offsetWidth}px`
        }
    }
  },
  watch: {
    attachments(newVal) {
        this.$emit('update:attachments', newVal)
    },
    show(newVal) {
        if(newVal !== this.internalShow) {
            this.internalShow = !!newVal
        }
    },
    internalShow(newVal) {
        if (this.show !== newVal) {
            this.$emit('update:show', !!newVal)
        }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '_assets/AttachmentDialog';
</style>
